<template>
  <div class="base-layout--default">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DefaultPage',
  // created() {
  //   console.log('DefaultPage created')
  // },
  // activated() {
  //   console.log('DefaultPage activated')
  // },
}
</script>
